export enum WidgetMode {
  off = 'off',
  on = 'on',
  trackOnly = 'trackOnly',
}
